<app-modal
  title="Add Party"
  subtitle="Select an existing person or create a new one."
  (closed)="closed.emit()"
>
  <!-- Tab switcher -->
  <div class="flex items-center bg-slate-100 rounded-3xl px-1 py-1 gap-1 mb-5 w-fit">
    <button
      type="button"
      (click)="activeTab.set('select')"
      class="px-5 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer"
      [ngClass]="
        activeTab() === 'select'
          ? 'bg-white text-navy-900 shadow-sm'
          : 'text-slate-500 hover:text-navy-700'
      "
    >
      Select Existing
    </button>
    <button
      type="button"
      (click)="activeTab.set('create')"
      class="px-5 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer"
      [ngClass]="
        activeTab() === 'create'
          ? 'bg-white text-navy-900 shadow-sm'
          : 'text-slate-500 hover:text-navy-700'
      "
    >
      Create New
    </button>
  </div>

  <!-- ── SELECT TAB ─────────────────────────────────────────────────────── -->

  @if (activeTab() === 'select') {
    <input
      type="text"
      placeholder="Search by name…"
      class="w-full mb-3"
      (input)="onSearch($any($event.target).value)"
    />

    @if (personsLoading()) {
      <p class="text-xs text-slate-400 py-6 text-center">Loading…</p>
    } @else if (filteredPersons().length === 0) {
      <p class="text-xs text-slate-400 py-6 text-center">No persons found.</p>
    } @else {
      <div class="flex flex-col gap-1 max-h-64 overflow-y-auto -mx-1 px-1">
        @for (p of filteredPersons(); track p.id) {
          <button
            type="button"
            (click)="selectPerson(p)"
            class="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-50 transition-colors cursor-pointer text-left w-full"
          >
            <div
              class="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center shrink-0"
            >
              <img src="/icons/user-icon.svg" class="w-4 h-4" alt="" />
            </div>
            <div class="min-w-0">
              <p class="text-xs font-semibold text-navy-900">
                {{ p.surnames }}, {{ p.firstName }}
                @if (tagline(p)) {
                  <span class="font-normal text-slate-400">· {{ tagline(p) }}</span>
                }
              </p>
              @if (p.personTypeName) {
                <p class="text-2xs text-slate-400">{{ p.personTypeName }}</p>
              }
            </div>
          </button>
        }
      </div>
    }
  }

  <!-- ── CREATE TAB ─────────────────────────────────────────────────────── -->

  @if (activeTab() === 'create') {
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-semibold text-navy-600 tracking-wider">First Name</label>
        <input
          type="text"
          placeholder="Enter first name…"
          class="w-full"
          [value]="firstName()"
          (input)="firstName.set($any($event.target).value)"
          [class.border-red-400]="showErrors() && !firstName().trim()"
          [class.ring-2]="showErrors() && !firstName().trim()"
          [class.ring-red-100]="showErrors() && !firstName().trim()"
        />
        @if (showErrors() && !firstName().trim()) {
          <span class="text-2xs text-red-500">Required</span>
        }
      </div>
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-semibold text-navy-600 tracking-wider">Last Name</label>
        <input
          type="text"
          placeholder="Enter last name…"
          class="w-full"
          [value]="surnames()"
          (input)="surnames.set($any($event.target).value)"
          [class.border-red-400]="showErrors() && !surnames().trim()"
          [class.ring-2]="showErrors() && !surnames().trim()"
          [class.ring-red-100]="showErrors() && !surnames().trim()"
        />
        @if (showErrors() && !surnames().trim()) {
          <span class="text-2xs text-red-500">Required</span>
        }
      </div>
    </div>
  }

  <!-- Footer -->
  <div modal-footer class="flex items-center justify-end gap-3">
    <button
      type="button"
      (click)="closed.emit()"
      class="px-4 py-2 text-xs font-semibold text-slate-500 hover:text-navy-900 transition-colors cursor-pointer"
    >
      Cancel
    </button>
    @if (activeTab() === 'create') {
      <button
        type="button"
        (click)="onSubmitCreate()"
        [disabled]="creating()"
        class="px-5 py-2 text-xs font-semibold text-white bg-accent-500 hover:opacity-90 rounded-xl transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {{ creating() ? 'Creating…' : 'Create & Add' }}
      </button>
    }
  </div>
</app-modal>
